<template>
    <div class="black--text">
        <ckeditor :editor="editor" v-model="editorData" :config="editorConfig" @ready="onReady" @blur="onEditorBlur" @input="onEditorInput"></ckeditor>
    </div>
</template>

<script>

import CustomEditor from '../../../plugins/document/ckeditor';
//import '@ckeditor/ckeditor5-build-decoupled-document/build/translations/de';

export default {
    name: 'Cke',
    props: ['label', 'format', 'name', 'value', 'blocked'],
    components: {
        //ckeditor: CKEditor.component
        //CustomEditor: () => import('../../../plugins/document/ckeditor')
    },
    data: () => ({
        loading: false,
        dialog: false,
        ready: false,
        dirty: false,
        loaded: false,
        changed: false,
        search: null,
        editor: CustomEditor,
        editorData: 'blank',
        tempValue: '',
        editorConfig: {
            toolbar: {
            shouldNotGroupWhenFull: true,
                items: [
                'undo',
                'redo',
                '|',
                'bold',
                'underline',
                'italic',
                '|',
                'alignment',
                '|',
                'outdent',
                'indent',
                '|',
                'fontFamily',
                'fontSize',
                '|',
                'bulletedList',
                'numberedList',
                '|',
                'fontColor',
                'fontBackgroundColor',
                '|',
                'pageBreak',
                '|',
                'removeFormat',
                '|',
                'heading',
                ]
            },
            language: 'de',
            fontFamily: {
                options: [
                    'default',
                    'Arial, Helvetica, sans-serif',
                    'Courier New, Courier, monospace',
                    'Georgia, serif',
                    'Lucida Sans Unicode, Lucida Grande, sans-serif',
                    'Tahoma, Geneva, sans-serif',
                    'Times New Roman, Times, serif',
                    'Trebuchet MS, Helvetica, sans-serif',
                    'Verdana, Geneva, sans-serif',
                    'DejaVu Sans, serif',
                ],
                supportAllValues: true
            },
        },
    }),
    methods: {
        onReady( editor )  {
            editor.ui.getEditableElement().parentElement.insertBefore(
                editor.ui.view.toolbar.element,
                editor.ui.getEditableElement()
            );
            this.editorData = this.tempValue
            this.ready = true
            //console.log(Array.from( editor.ui.componentFactory.names() ))
        },
        onEditorBlur() {
            //if(this.dirty) this.$emit('changed', this.editorData)
            if(this.changed || this.dirty) this.$emit('changed', this.editorData)
        },
        onEditorInput() {
            if(this.changed && !this.dirty) {
                //console.log('changed')
                this.$emit('changed', this.editorData)
                this.dirty = true
            } else {
                if(this.editorData) this.changed = true
                //console.log('changed 0')
            }
        },
        onClick(e) {
            console.log(e)
            console.log(this.editorData)
        }
    },
    mounted() {
    },
    beforeDestroy() {
    },
    watch: {
        value(newValue) {
            if(!newValue) newValue = ''
            if(this.ready) {
                if(!this.loaded) {
                    this.editorData = newValue
                    this.loaded = true
                }
            } else { this.tempValue = newValue }
        },
    },
};
</script>
<style>
.ck-toolbar {
    background-color: #aaaaaa !important;
}
.ck-content {
    background-color: #aaaaaa !important;
}
.ck-editor__editable_inline {
    height: 530px;
}
</style>
